.label {
  color: var(--mantine-color-white);
}

.label[data-active] {
  color: var(--mantine-color-white);
}
